module.exports = __webpack_public_path__ + "img/chat1.b3335043.png";